import React, {
  useState,
  useRef,
  useContext
}                               from 'react';
import { useTranslation}        from 'react-i18next';
import { toast }                from 'react-toastify';
import PartnerContext           from './context';
import SupervisedUserCircle     from '@material-ui/icons/SupervisedUserCircle';
import List                     from '~/containers/List';
import Request                  from '~/providers/Request';
import ModalDelete              from '~/components/ModalDelete';
import {
  showPartner,
  editPartner,
  createPartner
}                               from '~/config/routes';
import moment from 'moment';
import { AbilityContext }       from '~/contexts/Can';

function PartnerList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(PartnerContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`partner.attributes.${attr}`);

  function handleDeletionModal(id, title){
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/partner/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Partners')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Partners')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'Partners')) {
    actions.push('del');
  }
  if(ability.can('show', 'Partners')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createPartner}
        routeToEdit={editPartner}
        routeToShow={showPartner}
        listEl={listEl}
        path={'/admin/partner/'}
        actions={actions}
        paperProps={{
          Icon: SupervisedUserCircle,
          iconColor: 'blue',
          title: t('partner.defPlural'),
        }}
        columns={[
          { title: trAttr('id'), field: 'id', type: 'numeric', precision: 0, includeThousandsSeparator: false },
          { title: trAttr('name'), field: 'name', type: 'string' },
          { title: trAttr('code'), field: 'code', type: 'string' },
          { title: trAttr('doctor'), field: 'doctor', type: 'boolean' },
          { title: trAttr('created_at'), field: 'created_at', type: 'datetime' },
          { title: trAttr('updated_at'), field: 'updated_at', type: 'datetime' },
        ]}
        context={PartnerContext}
        recordMap={
          record => ({
            ...record,
            created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
            updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(PartnerList);
